module.exports = __webpack_public_path__ + "static/media/26UNRWA19.43cea4a3.jpg";